import { render, staticRenderFns } from "./home2025.vue?vue&type=template&id=2ba6f632&scoped=true"
import script from "./home2025.vue?vue&type=script&lang=js"
export * from "./home2025.vue?vue&type=script&lang=js"
import style0 from "./home2025.vue?vue&type=style&index=0&id=2ba6f632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6f632",
  null
  
)

export default component.exports